import type { ValueOf } from '@vy/utils';

export const REPORT_TYPES = Object.freeze({
  ALL_REPORTS: 'All reports',
  CONTRACTS: 'Contracts Report',
  RECURRING_REVENUE: 'Recurring Revenue Report',
  NRR_GRR: 'NRR / GRR Report',
  COMMITMENT_USAGE: 'Commitment Usage',
  UNCHARGED_USAGE: 'Uncharged Usage',
  ANONYMOUS_CUSTOMERS: 'Anonymous Customers',
  AR_AGING: 'AR Aging',
  COMMITMENT_VS_USAGE: 'Commitment vs Usage',
  CUSTOMER_REVENUE: 'Revenue Analysis',
  CUSTOMERS: 'Customers',
  FAILED_INVOICE_DELIVERIES: 'Failed Invoice Deliveries',
  MONTHLY_CLOSURE: 'Monthly Closure',
  PRODUCTS_USAGE: 'Usage by Product',
  CUSTOMER_MASTER: 'Customer Master Report',
  UPCOMING_INVOICES: 'Billing Forecast Report',
  UNAPPROVED_INVOICES: 'Unapproved Invoices',
  USAGE: 'Usage Report',
  USAGE_REPORT_V2: 'Usage Report v2',
  JOURNAL_ENTRIES: 'Journal Entries',
  UNMETERED_EVENTS: 'Unmetered Events',
});

export type ReportType = ValueOf<typeof REPORT_TYPES>;
